module.exports = __webpack_public_path__ + "img/icon_xmr.9bf280c7.svg";